import { useEffect } from "react";
import { useApiContext } from 'context/ApiContext';

// @mui material components
import 'leaflet/dist/leaflet.css';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TurbineDashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TurbineDashboardNavbar from "examples/Navbars/DashboardNavbar";

// Overview page components
import ParkForm from "layouts/parkAdministration/ParkForm";

function ParkAdministration() {
    const { APIRequestType, getAPI } = useApiContext();

    useEffect(() => {
        getAPI(APIRequestType.GET_PARK);

        console.log(" 0 0 1    Park Adm");
    }, []);

    return (
        <TurbineDashboardLayout>
            <TurbineDashboardNavbar />
            <MDBox>
                <MDBox display="flex" justifyContent="flex-end" mr={3}>
                    <MDTypography
                        variant="button"
                        fontWeight="bold"
                        color="dark"
                        fontSize="1.2rem"
                    >
                        {"MODIFY Park"}
                    </MDTypography>
                </MDBox>
                <ParkForm />
            </MDBox>
        </TurbineDashboardLayout >
    );
}

export default ParkAdministration;